import React from "react";
import { Route, Redirect } from "react-router-dom";

import { checkRoles, isAuthenticated } from "../common";

const PrivateRoute = ({
  role,
  path,
  component: Component,
  layout: Layout,
  ...rest
}) => {

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated()) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{
                pathname: "/",
                state: { from: props.location },
              }}
            />
          );
        }

        // if (!checkRoles(role)) {
        //   return (
        //     <Redirect
        //       to={{
        //         pathname: "/403",
        //         state: { from: props.location },
        //       }}
        //     />
        //   );
        // }
        // authorised so return component
        return (
          <Layout>
            <Component {...props} url={rest.path} />
          </Layout>
        );
      }}
    />
  );
};

export default PrivateRoute;